import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import useWindowSize from 'shared/hooks/useWindowSize';
import { actions as authActions, selectors as authSelectors } from 'userportal/ducks/auth';
import { selectors as applicationSelectors } from 'userportal/ducks/applications';
import { selectors as offerSelectors } from 'userportal/ducks/offers';
import { selectors as profileSelectors } from 'userportal/ducks/profile';
import Mobile from './Mobile';
import Desktop from './Desktop';
import styles from './Navigation.module.scss';

const Navigation = ({ menuOpened, onToggleMenu, noNavigationBottomPadding }) => {
  const dispatch = useDispatch();

  const loggedIn = useSelector(authSelectors.isLoggedIn);
  const user = useSelector(authSelectors.getUser);
  const unreadApplicationChangesCount = useSelector(applicationSelectors.getUnreadChangesCount);
  const unreadOfferChangesCount = useSelector(offerSelectors.getUnreadOfferChangesCount);
  const hasInsufficientProfile = useSelector(profileSelectors.hasInsufficientProfile);
  const language = useSelector(authSelectors.getLanguage);

  const handleLogout = (event) => {
    event.preventDefault();
    dispatch(authActions.logout());
  };

  const handleSetLanguage = (lang) => {
    dispatch(authActions.setLanguage(lang));
  };

  const { isMobileView } = useWindowSize();


  return (
    <header id="navigation" className={styles.navigation}>
      {isMobileView ? (
        <Mobile
          loggedIn={loggedIn}
          user={user}
          logout={handleLogout}
          unreadApplicationChangesCount={unreadApplicationChangesCount}
          unreadOfferChangesCount={unreadOfferChangesCount}
          hasInsufficientProfile={hasInsufficientProfile}
          opened={menuOpened}
          onToggleMenu={onToggleMenu}
          onChangeLanguage={handleSetLanguage}
          language={language}
        />
      ) : (
        <Desktop
          loggedIn={loggedIn}
          user={user}
          logout={handleLogout}
          unreadApplicationChangesCount={unreadApplicationChangesCount}
          unreadOfferChangesCount={unreadOfferChangesCount}
          hasInsufficientProfile={hasInsufficientProfile}
          onChangeLanguage={handleSetLanguage}
          language={language}
          noBottomPadding={noNavigationBottomPadding}
        />
      )}
    </header>
  );
};

Navigation.propTypes = {
  onToggleMenu: PropTypes.func,
  menuOpened: PropTypes.bool,
  noNavigationBottomPadding: PropTypes.bool,
};

Navigation.defaultProps = {
  onToggleMenu() {},
  menuOpened: false,
  noNavigationBottomPadding: false,
};

export default Navigation;
